/**
 * Whether the current permission set is trustworthy enough to dispatch on.
 *
 * - Cold start: not fetched yet → not ready (show loading).
 * - Just after login: login() seeds permissions:[] (isFetched=true) then kicks
 *   a background refetch (isFetching=true). With no real permissions yet we must
 *   stay "not ready" so a privileged user does not flash the fallback.
 * - Steady-state background refetch (e.g. network reconnect): real permissions
 *   are already cached (permissionCount > 0) → stay ready so the dashboard is
 *   not unmounted/remounted (which would refetch every widget).
 * - Genuinely permission-less user: settles to ready once the fetch finishes.
 */
export function arePermissionsReady(input: {
    permissionCount: number
    isFetched: boolean
    isFetching: boolean
}): boolean {
    if (input.permissionCount > 0) return true
    return input.isFetched && !input.isFetching
}
